import { createFileRoute, redirect } from '@tanstack/react-router';
import { TabbedPageLayout, type RoutedTab } from '@/components/tabbed-page-layout';
import { hasPermission } from '@/lib/permissions';

export const Route = createFileRoute(
  '/_auth/_side-layout/settings_/organization',
)({
  component: () => (
    <TabbedPageLayout
      title="Organization"
      description="Manage your organization details."
      tabs={TABS}
    />
  ),
  beforeLoad: async ({ context }) => {
    if (!hasPermission(context.userRole, { organization: ['update'] })) {
      throw redirect({ to: '/' });
    }
  },
});

const TABS: RoutedTab[] = [
  { to: '/settings/organization/details', label: 'Details' },
  { to: '/settings/organization/currency', label: 'Currency' },
];
